import { Buffer } from "buffer";
import process from "process";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./app/store";
import { fetchClientIP } from "./utils/detection";
import { setDynamicClientIP } from "./services/api/config";
import "./index.css";

window.Buffer = window.Buffer || Buffer;
window.process = process;

// Fetch Client IP on startup
fetchClientIP().then((ip) => {
    console.log("Client IP detected:", ip);
    setDynamicClientIP(ip);
}).catch(err => {
    console.error("Unable to detect IP, using fallback", err);
});

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);
